import React from "react";
import { useState } from "react";
import {
	Box,
	List,
	ListItemText,
	Typography,
	ListItem,
	Divider,
	IconButton,
} from "@mui/material";
import { Percent, CurrencyExchange } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import SummaryList from "./SummaryList";
import { useTranslation } from "react-i18next";
import { useTodayNetWorthQuery } from "../../../../services/queryHooks";
import { Loading } from "../../../../components/common/Loading";

export default function AccounsSummary({ categoryKeys }) {
	const theme = useTheme();
	const userCurrency = localStorage.getItem("userCurrency");
	const [isPercent, setIsPercent] = useState(false);

	const { t } = useTranslation();
	const { data: todayNetWorth, isLoading } = useTodayNetWorthQuery();

	if (isLoading) {
		return <Loading />;
	}

	return (
		<Box sx={{ flex: 0.6 }}>
			<List
				sx={{
					flexGrow: 1,
					backgroundColor: theme.palette.background.paper,
					borderRadius: "10px",
					p: 0,
				}}
			>
				<ListItem sx={{ pt: 0, pb: 0 }}>
					<ListItemText>
						<Typography
							variant="h6"
							gutterBottom
							sx={{ marginBottom: 0 }}
						>
							{t("summary")}
						</Typography>
					</ListItemText>
					<ListItemText sx={{ textAlign: "right" }}>
						<IconButton
							sx={{ minWidth: "auto" }}
							onClick={() => setIsPercent(true)}
						>
							<Percent sx={{ cursor: "pointer" }} />
						</IconButton>
						<IconButton
							sx={{ minWidth: "auto" }}
							onClick={() => setIsPercent(false)}
						>
							<CurrencyExchange sx={{ cursor: "pointer" }} />
						</IconButton>
					</ListItemText>
				</ListItem>
				<Divider />

				<SummaryList
					title={t("assets")}
					data={todayNetWorth?.assets ?? {}}
					color={theme.palette.values.positive}
					isPercent={isPercent}
					categoryKeys={categoryKeys}
				/>
				<SummaryList
					title={t("liabilities")}
					data={todayNetWorth?.liabilities ?? {}}
					color={theme.palette.values.negative}
					isPercent={isPercent}
					categoryKeys={categoryKeys}
				/>
				<ListItem
					sx={{
						pt: 0,
						pb: 0,
						borderRadius: "0 0 10px 10px",
						backgroundColor:
							todayNetWorth?.netWorth != null &&
							todayNetWorth.netWorth < 0
								? theme.palette.background.negative
								: theme.palette.background.positive,
						color:
							todayNetWorth?.netWorth != null &&
							todayNetWorth.netWorth < 0
								? theme.palette.values.negative
								: theme.palette.values.positive,
					}}
				>
					<ListItemText>
						<Typography
							variant="h6"
							gutterBottom
							sx={{
								marginBottom: 0,
								textWrap: "nowrap",
								fontWeight: "bold",
							}}
						>
							{t("nettWorth")}
						</Typography>
					</ListItemText>
					<ListItemText
						sx={{
							textAlign: "right",
							ml: 3,
							textWrap: "nowrap",
						}}
					>
						<Typography
							variant="h6"
							gutterBottom
							sx={{ marginBottom: 0, fontWeight: "bold" }}
						>
							{`${todayNetWorth?.netWorth.toFixed(2).toLocaleString() ?? 0} ${userCurrency}`}
						</Typography>
					</ListItemText>
				</ListItem>
			</List>
		</Box>
	);
}
